import { createElement } from "react";
import "./Typography.scss";

export const Typography = ({ className, label, type, style, onClick }) => {
  return createElement(
    type,
    {
      className,
      style,
      onClick,
    },
    label
  );
};
